import {
  FUNNEL_SESSION_STORAGE_KEY_PREFIX,
  FUNNEL_SESSION_TTL_HOURS,
} from "../constants.js";

/**
 * Generate the inline JavaScript that manages funnel session tracking.
 * This script runs on every funnel step page load:
 * 1. Reads or creates a UUID in localStorage (with TTL expiry)
 * 2. Injects it as a hidden form field (_funnel_session_id) into all forms
 *    that have a data-funnel-step-id attribute
 *
 * The script content is constant per siteId — all steps in the same funnel
 * share the same script, so one CSP hash covers all pages.
 *
 * Session data is stored as JSON {id, ts} to support TTL-based expiry.
 * After FUNNEL_SESSION_TTL_HOURS, the session is considered expired and
 * a new one is created.
 */
export function generateSessionScript(siteId: string): string {
  // Defense-in-depth: strip non-alphanumeric/hyphen chars from siteId
  const safeSiteId = siteId.replace(/[^a-zA-Z0-9-]/g, "");
  const key = `${FUNNEL_SESSION_STORAGE_KEY_PREFIX}${safeSiteId}`;
  const ttlMs = FUNNEL_SESSION_TTL_HOURS * 60 * 60 * 1000;

  return `(function(){var k='${key}';var ttl=${ttlMs};var raw=localStorage.getItem(k);var id;if(raw){try{var d=JSON.parse(raw);if(d.ts&&Date.now()-d.ts<ttl){id=d.id}}catch(e){}}if(!id){id=crypto.randomUUID();localStorage.setItem(k,JSON.stringify({id:id,ts:Date.now()}))}document.querySelectorAll('[data-funnel-step-id]').forEach(function(f){var h=document.createElement('input');h.type='hidden';h.name='_funnel_session_id';h.value=id;f.appendChild(h)})})();`;
}
